import { Component, OnInit, Input, SimpleChanges, ViewChild } from '@angular/core';
import { PortfolioService } from 'src/app/services/portfolio/portfolio.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar, MatTableDataSource, MatPaginator, MatSort, MatDialog } from '@angular/material';
import { Observable } from 'rxjs';
import { FilterService } from '../../services/filter.service';
import { QuizListModalComponent } from 'src/app/quiz/quiz-list-modal/quiz-list-modal.component';

@Component({
  selector: 'app-learner-portfolio',
  templateUrl: './learner-portfolio.component.html',
  styleUrls: ['./learner-portfolio.component.scss']
})
export class LearnerPortfolioComponent implements OnInit {

  // staticForms = ['Emergency Phone Call', 'Health And Safety', 'Manual Handling', 'Emergency Protection Of The Line', 'Maintenance Schedule','Track Inspection Report']
  statuses = ['Pending', 'Saved', 'Submitted', 'Completed', 'Requested for Resubmission', 'Re-Submitted']
  staticForms = []
  portfolio: any;
  allSessions: any;
  allSessionsCopy: any;
  sort: MatSort;
  paginator: MatPaginator;
  displayedColumns: string[] = ['session', 'title'];
  dataSource: MatTableDataSource<any>;
  filterActive: Boolean = false;
  noDataMsg = {
    title: "No Titles!",
    data: "not yet, 'title' added any Titles"
  }
  afterFilter: any;
  loading: boolean = false;
  learnerId: any;
  searchText: string
  tooltip: string;
  page = 'User'
  selectedJob

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _portfolioService: PortfolioService,
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _filter: FilterService
  ) {
    this.dataSource = new MatTableDataSource(this.allSessions);
  }

  @Input('learnerObj') learnerObj;
  @Input('singleJob') jobDetails


  ngOnInit() {

    this.activatedRoute.params.subscribe(params => {
      console.log('params', params)
      this.learnerId = params.id
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('learnerObj', changes);
    if (changes.learnerObj && changes.learnerObj.currentValue) {
      this.learnerObj = changes.learnerObj.currentValue
      this.getSessions()
    }

    if (changes.jobDetails && changes.jobDetails.currentValue) {

      this.selectedJob = changes.jobDetails.currentValue[0]
      console.log("what is the selected job data", this.selectedJob);
      this.getSessions()
    }

  }

  submissionRedirection(portfolio) {
    console.log('portfolio', portfolio);
    if (portfolio.isStatic) {
      switch (portfolio.index) {
        case 0:
          this.router.navigate(['/emergency-phone-call'], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
          break;

        case 1:
          this.router.navigate(['/health-and-safety'], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
          break;

        case 2:
          this.router.navigate(['/manual-handling'], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
          break;

        case 3:
          this.router.navigate(['/emergency-protection'], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
          break;

        case 4:
          this.router.navigate(['/maintenance-schedule'], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
          break;

        case 5:
          this.router.navigate(['/track-inspection'], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
          break;

        default:
          break;
      }

      // alert('IS STATIC')
    }
    else {
      this.router.navigate(['/learnerAllotment/' + portfolio._id], { queryParams: { courseType: 'Level2', sessionType: portfolio.sessionType, learnerId: this.learnerId } })
    }
  }

  statusChanged(event) {
    this.afterFilter = null
    console.log("event", event);
    let temp = [];
    this.filterActive = true;
    this.allSessions = this.allSessionsCopy
    if (event.value.length) {
      event.value.reverse().forEach(singleValue => {
        console.log("this.allSessionsCopy", this.allSessionsCopy);

        let sortedList = this.allSessionsCopy.filter(
          a => (
            a.quizId.some(function (x) {
              if (x.status && x.status == singleValue) {
                return x.status == singleValue
              }

            })
          )
        )
        console.log("sortedList", sortedList);
        temp = temp.concat(sortedList)
      })
      this.allSessions = temp
      console.log("temp--- ", temp)
      if (this.allSessions.length <= 0) {
        this.afterFilter = {
          title: "No Quiz!",
          data: "Sorry, no status matched your search"
        }

      }
      this.updateData(this.allSessions)
    } else {
      this.filterActive = false;
      this.allSessions = this.allSessionsCopy
      this.updateData(this.allSessions)
    }
  }

  getStatusClass(item) {
    if (item.status) {
      switch (item.status) {
        case 'Submitted':
          this.tooltip = 'Submitted';
          return 'submitted'
          break;

        case 'Completed':
          this.tooltip = 'Completed';
          return 'completed'
          break;

        case 'Requested for Resubmission':
          this.tooltip = 'Requested for Resubmission';
          return 'requested'
          break;

        case 'Re-Submitted':
          this.tooltip = 'Re-Submitted';
          return 'resubmitted'
          break;

        case 'Saved':
          this.tooltip = 'Saved';
          return 'saved'
          break;

        default:
          this.tooltip = 'Pending';
          return 'pending'
          break;
      }
    } else {
      this.tooltip = 'Pending';
      return 'pending'
    }
  }
  // UTILITY
  filter(searchText) {
    this.afterFilter = null
    this.filterActive = true;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.filterActive = false;
      this.allSessions = this.allSessionsCopy
      // this.updateData(this.allSessions);
      return;
    }
    let tempDataSource = this._filter.filter(searchText, this.allSessions, ['title']);
    this.allSessions = tempDataSource
    // this.updateData(tempDataSource)
    if (tempDataSource.length <= 0) {
      this.afterFilter = {
        title: "No Session!",
        data: "Sorry, no sessions matched your search"
      }

    }
  }
  updateData(data) {
    console.log("UPDATING DATA = ", data)
    console.log("Emitting event getLearnersFromComponent with learners = ", data);
    this.dataSource = new MatTableDataSource(data);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      console.log("item", item, "property", property);
      switch (property) {
        case 'session': return item.sessionType;
        // case 'client.name': return item.client.name;
        // case 'location.title': return item.location.title;
        // case 'course.title':
        //   if (item.course)
        //     return item.course.title;
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    console.log("SETTING SORT TO = ", this.dataSource.sort)
    console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;
    // this.loading = false;

  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  quizListModel(portfolio) {
    console.log("portfolio", portfolio)
    let obj = {
      learnerId: this.learnerId,
      quiz: portfolio.quizId,
      sessionTitle: portfolio.title
    }
    if (portfolio.unitNo) {
      obj['unitNo'] = "Unit-" + portfolio.unitNo
    }
    this.openDialog(QuizListModalComponent, obj).subscribe(res => {

    })
  }

  // API Calls
  getSessions() {


    console.group(" Get Sessions ")

    console.log("in get session", this.learnerObj);

    if (this.learnerObj && this.selectedJob && this.selectedJob.course && this.selectedJob.course.portfolioId && this.learnerObj._id) {

      console.log(" ******* this.learnerObj.job.course.portfolioId ", this.selectedJob.course.portfolioId)
      console.log(" this.learnerObj._id ", this.learnerObj._id)

      this.loading = true;
      this
        ._portfolioService
        .getSessions(this.selectedJob.course.portfolioId, this.learnerObj._id, this.selectedJob._id)
        .subscribe(res => {
          console.log(" get sessions resss =>", res[0]);
          this.portfolio = res[0]
          let temp = []
          // for(let i = 0; i < 6; i++){
          //   let obj = {
          //     course : this.portfolio.course,
          //     files: [],
          //     portfolioId: this.portfolio._id,
          //     title: this.staticForms[i],
          //     sessionType: 'classroom',
          //     isStatic: true,
          //     index: i
          //   }
          //   temp.push(obj)
          // }
          this.allSessions = temp.concat(this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions))
          console.log("%c CONCATED ARRAY", "color:pink", this.allSessions);
          let userRole = JSON.parse(localStorage.getItem('userRoles'))
          // if(userRole.isLearner || userRole.isTrainer){
          this.allSessions = this.allSessions.filter((singleSession) => {
            if (singleSession.quizId && singleSession.quizId.length > 0) {
              return singleSession;
            }
          });
          // }
          this.allSessionsCopy = this.portfolio.classRoomSessions.concat(this.portfolio.practicalSessions)
          // if(userRole.isLearner || userRole.isTrainer){
          this.allSessionsCopy = this.allSessionsCopy.filter((singleSession) => {
            if (singleSession.quizId && singleSession.quizId.length > 0) {
              return singleSession;
            }
          });
          const index = this.allSessions.findIndex(x => x.title == 'Tools & Equipment');
          console.log("index of tools and quipment", index);

          let oneQuiz = this.allSessions.filter((o) => {
            return o.title == 'Tools & Equipment'
          })
          console.log("what is single quiz to remove", oneQuiz);
          let quizArray = oneQuiz[0].quizId

          // let id1 = "5f532e54695868276179af47"
          // console.log("index value==========", index);
          quizArray.splice("5f532e54695868276179af47", 1)

          quizArray.splice("5f532629695868276179af37", 1)

          quizArray.splice("5f532abe695868276179af3e", 1)
          console.log("array===========", quizArray);
          // oneQuiz['quizId'] =
          // let finalQuiz = oneQuiz.quizId.splice("5f532e54695868276179af47", 1)
          // console.log("what is final quiz of data0=====", finalQuiz);


          // }
          this.updateData(this.allSessions)

        })
    }
  }
}